export default __webpack_public_path__ + "5054e7e0e62fb4caa921914fec3f46e0.png";